import { Grid, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import DetailsModal from './DetailsModal';
import { useParams } from 'react-router-dom';
import { decodeQueryParamData } from 'utils/utils';
import { useEffect, useMemo, useState } from 'react';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import DetailPageHeader from 'components/header/DetailPageHeader';
import ListViewBudgetaryControl from './ListViewBudgetaryControl';
import { useGetAllIdentityCaseMutation } from 'store/features/process/processApi';

function BudgetaryControl() {
	const [item, setItem] = useState({});
	const [rerender, setRerender] = useState(0);
	const [dataList, setDataList] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const { id } = useParams();

	const paramsData = useMemo(() => {
		if (id) {
			return decodeQueryParamData(id);
		} else {
			return null;
		}
	}, [id]);

	const processCode = paramsData?.processCode ? paramsData?.processCode : null;

	const [getBudgetaryControlList, { data: budgetaryControlRes, isUninitialized, isError, isSuccess, isLoading }] = useGetAllIdentityCaseMutation();

	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const handleModalOpen = () => {
		setOpenModal(true);
	};

	const handleModalClose = () => {
		setOpenModal(false);
	};

	useEffect(() => {
		if (processCode && companyCode) {
			getBudgetaryControlList({
				operation: 'get-bulk',
				companyCode,
				processCode,
				suffixCode: '',
			});
		}
	}, [companyCode, processCode, rerender]);

	useEffect(() => {
		if (isSuccess) {
			const data = budgetaryControlRes
				?.filter((item) => item?.recordStatus !== 'deleted')
				.map((row, index) => ({
					// note: Do not reorder the tableDataObj serial, otherwise it rewrite the value with ...row.data
					key: index,
					IdentityActivationStatus: row?.activationStatus,
					...row.data,
					dateTime: row?.dateTime,
					activationStatus: row?.activationStatus,
					parkedData: row?.parkedData,
					recordStatus: row.recordStatus,
					version: row.version,
					history: row?.history?.length > 0 ? true : false,
					id: row._id,
					approverUserId: row?.approverUserId,
					creatorId: row?.creatorId,
					parkAction: row?.parkAction,
				}));

			setDataList(data);
		} else if (isError) {
			setDataList([]);
		}
	}, [isSuccess, isError]);

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<DetailPageHeader image={<SolutionCatalogIcon color="#ffffff" width="20px" height="20px" />} title={paramsData?.processName} />
				</Grid>

				<Grid item xs={12}>
					<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
						<ListViewBudgetaryControl
							data={dataList}
							setItem={setItem}
							showModal={handleModalOpen}
							isLoading={isLoading || isUninitialized}
						/>
					</Box>
				</Grid>
			</Grid>
			{openModal && (
				<DetailsModal
					item={item}
					setItem={setItem}
					data={dataList}
					showModal={openModal}
					setRerender={setRerender}
					handleClose={handleModalClose}
				/>
			)}
		</>
	);
}

export default BudgetaryControl;
